export const ReviewInstanceStatus = {
    ACTIVE: 'Active',
    COMPLETED: 'Completed',
} as const;

export type ReviewInstanceStatusValue =
    (typeof ReviewInstanceStatus)[keyof typeof ReviewInstanceStatus];
